<template lang="pug">
SspLayout(area="core")
  DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)" url-page-param="page")
    tr(slot="thead")
      th IP
      th User
      th Event Type
      th Time
      th User Agent
    tr(v-for="a in authentications")
      td {{a.ip}}
      td {{a.username}}
      td {{a.eventType}}
      td {{a.time | date}}
      td {{a.userAgent}}
</template>

<script>
import DataGrid from '@/components/ssp/DataGrid'
import Security from '@/service/apis/Security'
import { dateFilter } from '@/filters/filters'

export default {
  data: () => ({
    authentications: []
  }),
  methods: {
    fetchData(page) {
      const req = page.maxOffsetRequest()
      return Security.listAuthentications(req)
        .then((resp) => {
          this.authentications = resp.data.authentication
          return resp.data.totalRecords
        })
        .catch((e) => { this.$emit('error', e) })
    }
  },
  components: {
    DataGrid
  },
  filters: {
    date: dateFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/system/Authentications.vue